class Device {
  constructor(deviceId, userId, name, settings, playlist) {
    this.deviceId = deviceId;
    this.userId = userId;
    this.name = name;
    this.settings = settings;
    this.playlist = playlist;
  }
}

export default Device;
